// =============================================================================
// MeuDriver — ActivePackageWidget
// Widget compacto mostrando aulas restantes no pacote ativo do aluno
// =============================================================================

import { Link } from 'react-router-dom'
import { Package, ChevronRight } from 'lucide-react'
import { motion } from 'framer-motion'
import { useActiveStudentPackage } from '@/hooks/usePackages'
import { cn } from '@/lib/utils'
import { format, parseISO } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function ActivePackageWidget() {
  const { data: activePkg, isLoading } = useActiveStudentPackage()

  if (isLoading || !activePkg) return null

  const remaining  = activePkg.lessons_remaining ?? 0
  const total      = activePkg.lessons_total
  const pct        = Math.round(((total - remaining) / total) * 100)
  const expiresAt  = format(parseISO(activePkg.expires_at), "d 'de' MMMM 'de' yyyy", { locale: ptBR })
  const pkgName    = (activePkg as any).package?.name ?? 'Pacote ativo'

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      data-testid="active-package-widget"
    >
      <Link to="/aluno/pacotes">
        <div className="flex items-center gap-3 rounded-2xl border border-brand-200 bg-gradient-to-r from-brand-50 to-teal-50 px-4 py-3 hover:shadow-soft transition-all cursor-pointer">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-100">
            <Package className="h-5 w-5 text-brand-700" />
          </div>

          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-2 mb-1">
              <p className="text-sm font-semibold text-gray-900 truncate">{pkgName}</p>
              <span className={cn(
                'shrink-0 rounded-full px-2 py-0.5 text-xs font-bold',
                remaining <= 2 ? 'bg-red-100 text-red-600' : 'bg-brand-100 text-brand-700',
              )}>
                {remaining} aula{remaining !== 1 ? 's' : ''} restante{remaining !== 1 ? 's' : ''}
              </span>
            </div>
            <div className="h-1.5 bg-white/70 rounded-full overflow-hidden border border-brand-100">
              <div
                className="h-full rounded-full bg-gradient-to-r from-brand-500 to-teal-500 transition-all"
                style={{ width: `${pct}%` }}
              />
            </div>
            <p className="text-[11px] text-muted-foreground mt-0.5">
              Válido até {expiresAt}
            </p>
          </div>

          <ChevronRight className="h-4 w-4 text-gray-400 shrink-0" />
        </div>
      </Link>
    </motion.div>
  )
}
